<template>
    <div class="color-text-tag">
        <div class="color-circle" :style="{ backgroundColor: circleColor }"></div>
        <span class="tag-text">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'ColorAndTextTag',
    props: {
        circleColor: {
            type: String,
            default: '#D32F2F'
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.color-text-tag {
    display: inline-flex;
    align-items: center;
    height: 25px;
    min-width: 136px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 0 12px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: auto;

    .color-circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }

    .tag-text {
        font-family: $text-bold;
        font-size: 14px;
        color: #212121;
        white-space: nowrap;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
